<template>
  <div class="chip_wrapper">
    <div
      v-for="(filter, i) in computedFilters"
      :key="i" class="chip" :class="filter.includes ? 'chip__includes' : 'chip__excludes'"
      v-tooltip.top-middle="{content: filter.message, ...tooltipOptions}"
    >
      <span class="chip__name">{{ filter.message }}</span>
      <div @click="removeFilter(filter)" class="chip__button"></div>
    </div>
    <div class="remainder" v-if="remainderText">
      <span>{{ remainderText }}</span>
    </div>
    <div @click="clearFilters()" v-if="filters.length" class="chip chip__clear">
      <span class="chip__name">clear all</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterChips',
  props: {
    filters: Array,
    fieldLabels: Object
  },
  data () {
    return {
      tooltipOptions: {
        delay: { show: 100, hide: 100 },
        classes: 'rfx-tooltip-arrow'
      },
      chipCount: 3
    }
  },
  methods: {
    removeFilter (filter) {
      this.$emit('delete', filter)
    },
    clearFilters () {
      this.$emit('deleteAll')
    }
  },
  computed: {
    remainderText () {
      return this.filters.slice(this.chipCount).length && `+ ${this.filters.slice(this.chipCount).length} more`
    },
    computedFilters () {
      const lookup = {
        'in': 'Equal to',
        '=': 'Equal to',
        '!=': 'Not Equal to',
        '>': 'Greater Than',
        '<': 'Less Than',
        '>=': 'Greater Than/Equal to',
        '<=': 'Less Than/Equal to',
        'like': 'Containing'
      }
      return this.filters.map(filter => ({ ...filter }))
        .slice(0, this.chipCount)
        .reduce((previous, current) => {
          if (current.type === 'in' && Array.isArray(current.value)) { // handle 'in' filters
            for (let i = 0; i < current.value.length; i++) {
              previous.push({
                field: current.field,
                type: 'in',
                value: current.value[i]
              })
            }
          } else {
            previous.push(current)
          }
          return previous
        }, [])
        .map(filter => {
          const excludes = filter.value.startsWith('~')
          let computedValue = excludes ? filter.value.slice(1) : filter.value
          let excludesText = excludes ? ' not ' : ' '
          let fieldLabel = this.fieldLabels[filter.field]
          let formattedType = lookup[filter.type] || filter.type
          if (filter.field === 'publish_date') {
            if (filter.type === '<') {
              formattedType = 'Before'
            } else if (filter.type === '>') {
              formattedType = 'After'
            }
          }
          filter.message = `${fieldLabel}${excludesText}${formattedType} ${computedValue}`
          filter.message = filter.message.toLowerCase()
          filter.includes = !excludes
          return filter
        })
    }
  }
}
</script>

<style scoped lang="scss">
.chip_wrapper {
    display: flex;
}
.remainder {
  width: 25%;
  span {
    line-height: 30px;
  }
}
.chip {

    padding: 3px 0 3px 12px;
    border-radius: 15px;
    height: 30px;
    margin-right: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    cursor: default;
    min-width: 20%;

    &__includes {
      background-color: $rfx-light-blue;
    }
    &__excludes {
      background-color: $rfx-light-red;
    }

    &__clear {
      background-color: $rfx-medium-march;
      cursor: pointer;
      font-weight: 500;
      padding: 0 10px;
      min-width: fit-content;
      &:hover {
        span {
            color: $rfx-silver;
          }
      }
    }

    &__name {
        font-size: 12px;
        color: #fff;
        text-transform: lowercase;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__button {
        position: relative;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        pointer-events: auto;
        cursor: pointer;

        position: relative;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        pointer-events: auto;

        &:before,
        &:after {
            position: absolute;
            right: 12px;
            top: 9px;
            content: " ";
            height: 12px;
            width: 2px;
            background-color: #fff;
        }

        &:before {
            transform: rotate(45deg);
        }

        &:after {
            transform: rotate(-45deg);
        }

        &:hover {
            &:before, &:after {
                background-color: $rfx-silver;
            }
        }
    }

}
</style>
